import React from 'react';

export default function ModelMeasurement({
  tmntData,
  fitInformation,
}) {
  return (
    <div className="overlay-measurement" data-testid="overlay-measurement">
      <span className="model-text">
        {tmntData?.modelText?.value ?? ''}
        :
      </span>
      <span>
        {`
          ${fitInformation?.ofpModelHeight?.replace(/&quot;/g, '"') ?? ''}
          ${tmntData?.inSizeText?.value?.toLowerCase() ?? ''} 
          ${fitInformation?.ofpModelSize ?? ''}
        `}
      </span>
    </div>
  );
}
